import { useState, useEffect } from "react";

const ProgressBar: React.FC = () => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        if (progress < 100) {
            const timer = setTimeout(() => {
                setProgress((prev) => prev + 1);
            }, 1000);
            return () => clearTimeout(timer); // Cleanup timeout
        }
    }, [progress]);

    return (
        <div className="flex items-center gap-4 w-full">
            <p className="text-[2vh] font-semibold">{progress}%</p>
            <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
                <div
                    className="bg-blue-500 h-full rounded-full transition-all duration-300"
                    style={{ width: `${progress}%` }}
                ></div>
            </div>
        </div>
    );
};


export default ProgressBar;